import { ContractTypeV2 } from "src/utils/enums/ContractTypeV2";
import { FinancialObjectiveEnum } from "src/utils/enums/FinancialObjectiveEnum";
import { WorkerEmploymentStatusEnum } from "src/utils/enums/WorkerEmploymentStatus";
import { SocialIconItemInterface, WorkerLicenseRecord, WorkerTrainingRecord } from "../applicants/ApplicantListItem";
import { WorkerLanguageProficiencyEnum } from "src/utils/enums/WorkerLanguageProficiency";
import { ChatMessageSenderType, ChatMessageType } from "src/utils/enums/ChatMessageTypeEnum";
import { WorkerExperienceDurationEnum } from "src/utils/enums/WorkerExperienceDuration";
import { IndustriesEnum } from "src/utils/enums/IndustriesEnum";
import { SubIndustriesEnum } from "src/utils/enums/SubIndustriesEnum";
import { VideoCvItemInterface } from "../applicants/VideoCvItemInterface";
import { ApplicationStatusEnum } from "src/utils/enums/ApplicationStatus";

export enum NationalityCategory {
    SAUDI = 'SAUDI',
    SON_DAUGHTER_SAUDI_MOTHER = 'SON_DAUGHTER_SAUDI_MOTHER',
    NON_SAUDI = 'NON_SAUDI',
    SON_DAUGHTER_DISPLACED_TRIBE = 'SON_DAUGHTER_DISPLACED_TRIBE'
}

export interface WorkerExperienceRecord {
    id: string;
    jobTitle: string;
    employer: string;
    employerLogo: string;
    experienceDuration?: WorkerExperienceDurationEnum;
    industry?: IndustriesEnum;
    subIndustry?: SubIndustriesEnum;
    contractType?: ContractTypeV2;
    fromDate?: number;
    toDate?: number;
    isCurrent?: boolean;
    description?: string;
}

export enum EducationLevel {
    MIDDLE_SCHOOL_BELOW = 'MIDDLE_SCHOOL_BELOW',
    HIGH_SCHOOL = 'HIGH_SCHOOL',
    DIPLOMA = 'DIPLOMA',
    BACHELOR = 'BACHELOR',
    MASTERS_PHD = 'MASTERS_PHD',
}


export interface WorkerEducationRecord {
    id: string;
    institution: string;
    institutionLogo: string;
    fieldOfStudy: string;
    level: EducationLevel;
    graduationYear?: number;
}

export interface WorkerRelevantExperienceItemForPartner {
    jobTitle: string;
    isHighlighted: boolean;
    months?: number;
    years?: number;
    specialization?: string;
}

export interface WorkerExperienceTagForPartner {
    category: string;
    industry: string;
}

export interface WorkerSkillItemForPartner {
    name: string;

    isHighlighted: boolean;
}

export interface WorkerLanguageRecord {
    id: string;
    language: string;
    proficiency: WorkerLanguageProficiencyEnum;
}

export interface ChatMessageRespInfo {
    id: number;
    chatId?: string;
    msgType: ChatMessageType;
    senderType: ChatMessageSenderType;
    msg?: string;
    fileUrl?: string;
    createdAt: number;
    seenByPartnerAt?: number;
    seenByWorkerAt?: number;
    applicationUpdate?: any;
}


export interface RecentApplicationDetails {
    jobTitle: string;
    status: ApplicationStatusEnum;
}

export enum TransportationMethod {
    CAR = 'CAR',
    TAXI = 'TAXI',
    PUBLIC = 'PUBLIC',
}

export enum SubmissionStatusEnum {
    NOT_PROVIDED = 'NOT_PROVIDED',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
}

export enum LanguageProficiencyEnum {
    BEGINNER = 'BEGINNER',
    INTERMEDIATE = 'INTERMEDIATE',
    ADVANCED = 'ADVANCED',
}


export interface CvSearchProfileInterface {
    externalId?: string;
    firstName?: string;
    lastName?: string;
    links?: SocialIconItemInterface[];
    profileImageFull?: string;
    profileImage?: string;
    pdfCvUrl?: string;
    nationality?: string;
    nationalityCategory?: NationalityCategory;
    hasSaudiRelative?: boolean;
    age?: number;
    gender?: string;
    financialObjective?: FinancialObjectiveEnum;
    preferredJobTitles?: string[];
    city?: string;
    district?: string;
    hasHealthCard?: boolean;
    hasVideoCv?: boolean;
    hasPdfCv?: boolean;
    isFavorite?: boolean;
    isUnlocked?: boolean;
    speaksEnglish?: boolean;
    hasSpecialNeed?: boolean;
    isOnline?: boolean;
    previouslyRejected?: boolean;
    previouslyRejectedJobTitle?: string;
    previouslyRejectedJobLocation?: string;
    highestEducation?: WorkerEducationRecord;
    canViewDetails?: boolean;
    specialNeedsType?: string;
    willingToGosi?: boolean;
    wantedContractTypes?: ContractTypeV2[];
    isProfileImageVerified?: boolean;
    hasPreviousExperience?: boolean;
    expectedSalary?: number;
    maxSalary?: number;
    mobile?: string;
    email?: string;
    isFar?: boolean;
    isNearby?: boolean;
    distance?: number;
    skills?: WorkerSkillItemForPartner[];
    highlightedSkills?: WorkerSkillItemForPartner[];
    relevantExperiences?: WorkerRelevantExperienceItemForPartner[];
    exactExperience?: WorkerRelevantExperienceItemForPartner;
    isStudent?: boolean;
    shortBio?: string;
    lastMessage?: ChatMessageRespInfo;
    videoCv?: VideoCvItemInterface[];
    videoCvEn?: VideoCvItemInterface[];
    transportation?: TransportationMethod;
    bio?: string;
    hasNoExperience?: boolean;
    recentApplication?: RecentApplicationDetails;
    employmentStatus?: WorkerEmploymentStatusEnum;
    healthCardSubmissionStatus?: SubmissionStatusEnum;
    healthCardExpiryDate?: number;
    workExperience?: WorkerExperienceRecord[];
    exactExperienceDetails?: WorkerExperienceRecord[];
    education?: WorkerEducationRecord[];
    training?: WorkerTrainingRecord[];
    license?: WorkerLicenseRecord[];
    language?: WorkerLanguageRecord[];
    lastActiveAt?: number;

    // from applicant:
    workerNote?: string;
    newUpdatesCount?: number;
}